import React from "react";

const ConfigurationMapSection = props => {
  return (
    <div className="configuration-map-section">
      {props.children}
    </div>
  );
};

module.exports = ConfigurationMapSection;



// WEBPACK FOOTER //
// ./src/js/components/ConfigurationMapSection.js